import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Icon from '@material-ui/core/Icon';

import { getEventTypeProps } from 'utils/utilsDesign';

class AvatarIcon extends Component {
  render() {
    const { children, ...other } = this.props;
    const iconProps = getEventTypeProps(children);
    if (!iconProps) {
      return <div />;
    }
    const { iconName, color: backgroundColor } = iconProps;

    return (
      <Avatar style={{ backgroundColor }} {...other}>
        <Icon>{iconName}</Icon>
      </Avatar>
    );
  }
}

AvatarIcon.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default AvatarIcon;
